import { defineComponent as _defineComponent } from 'vue'
import { MultiJumpContainer  } from '@tencent/wphk-components-multi-jump-container';
import { ModuleName } from '@/types/module-type';
import { useMerchantLayoutInfo } from '../hooks/use-merchant-layout-info';


export default /*#__PURE__*/_defineComponent({
  __name: 'merchant-layout',
  props: {
    moduleName: null
  },
  setup(__props: any) {

const props = __props as { moduleName: ModuleName }


const { bannerLayoutList } = useMerchantLayoutInfo(props.moduleName);


return { __sfc: true,props, bannerLayoutList, MultiJumpContainer }
}

})